// extracted by mini-css-extract-plugin
module.exports = {"root":"ProjectSection-module--root--GpqHC","darker":"ProjectSection-module--darker--3O9I_","block":"ProjectSection-module--block--2dwRS"};